module.exports = __webpack_public_path__ + "img/talabash-mini.0c9fac0a.png";